import classNames from "classnames";
import { useContext, useState } from "react";
import { ContentContainer, marginStyles, positionStyles, widthStyles } from "ui";
import { BlocksContext } from "../../BlocksContext";
import { InlineSocialLinks } from "./InlineSocialLinks";
import { parseLinks } from "./parseLinks";

interface Props {
  blockId: string;
  links: string;
  updateBlock: (props: Partial<{ links: string }>) => void;
  buttonTextColor: string;
  buttonBackgroundColor: string;
}

export function SocialLinksBlock({ links, updateBlock, buttonTextColor, buttonBackgroundColor }: Props) {
  const { SocialLinksEditor, EditPopover } = useContext(BlocksContext);
  const [isEditorOpen, setIsEditorOpen] = useState(links === "");

  const linksArray = parseLinks(links);

  const handleUpdate = (links: string) => {
    updateBlock({ links });
    setIsEditorOpen(false);
  };

  return (
    <div className={positionStyles.relative}>
      <EditPopover
        isOpen={isEditorOpen}
        onOpen={() => setIsEditorOpen(true)}
        showEditButton={linksArray.length > 0}
        editor={<SocialLinksEditor links={links} onClose={() => setIsEditorOpen(false)} onUpdate={handleUpdate} />}
      />

      {linksArray.length > 0 ? (
        <InlineSocialLinks
          buttonTextColor={buttonTextColor}
          buttonBackgroundColor={buttonBackgroundColor}
          links={links}
        />
      ) : (
        <ContentContainer
          onClick={() => setIsEditorOpen(!isEditorOpen)}
          iconType="SocialInstagram"
          label="Add social media links"
          className={classNames(widthStyles.full, marginStyles.mt125)}
        />
      )}
    </div>
  );
}
